const zIndexes = {
  default: 1,
  navigation: 50,
  modal: 150,
}

export default zIndexes
